<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-panel-body>
                <form @submit.prevent="updateProduct" id="product_form">
                    <h4 :style="{marginBottom: '2rem', marginTop: '3rem'}">{{ $t('tag.enter_tag') }}</h4>
                    <tag-input style="width: 100%;"  v-model="tags" class="input" name="tag"></tag-input>
                    <tag-list  v-model="product.tags" style="padding: 10px 0" @detach="detach"></tag-list>
                    <div class="ml-auto">
                        <kt-button type="submit" class="ml-2"  variant="success" id="submit_btn">{{ $t('tag.submit') }}<i class="pl-2 fa fa-arrow-left"></i></kt-button>
                    </div>

                </form>

            </kt-panel-body>

        </kt-panel>
    </main-content>
</template>

<script>
    import { mapGetters } from 'vuex'
    import mainContent from '@/components/main-content'
    import tagInput from './components/tag-input'
    import tagList from './components/tag-list'
    import $ from 'jquery'
    import { KTApp } from '@/plugins/core/app'
    import { productService } from '@/common/api.service'
    import 'bootstrap-switch'

    export default {
        components: {
            mainContent,
            tagInput,
            tagList,
        },
        computed: {
            ...mapGetters('product', [
                'product', 'status'
            ]),

        },
        mounted() {
        },
        data() {
            return {
                hashid: this.$route.params.hashid,
                store_hashid: this.$route.params.store_hashid,
                tags: [],
                }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('product/find', vm.hashid)
            })
        },
        methods:{
            updateProduct(e) {
                let form = $(e.target)

                form.validate({
                    rules: {
                        tag: {
                            required: true,
                        },
                    },
                });
                if (this.tags){
                    let btn = $('#submit_btn')
                    KTApp.progress(btn)
                    productService.updateTags(this.tags,this.hashid)
                        .then(response => {
                            this.$store.dispatch('product/find', this.hashid)
                            this.showMsg(form, 'success',response.data.message)
                            this.tags = []
                        })
                        .catch(({response}) => {
                            if(response.data) {
                                this.showMsg(form, 'danger',response.data.message)
                                form.validate().showErrors(response.data.data)
                            }
                        })
                        .finally(() => {
                            KTApp.unprogress(btn)
                        })
                }

            },
            detach(tag){
                productService.detachTags(tag,this.hashid)
            }
        }
    }


</script>

<style scoped>

</style>